import { motion } from "framer-motion";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ProductOverview from "../components/ProductOverview";
import WhyCreatine from "../components/WhyCreatine";
import ClinicalValidation from "../components/ClinicalValidation";
import BenefitsGrid from "../components/BenefitsGrid";
import NutritionFacts from "../components/NutritionFacts";
import DirectionsForUse from "../components/DirectionsForUse";
import AboutBrand from "../components/AboutBrand";
import Footer from "../components/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="landing-page">
      {/* Texture overlay */}
      <div className="fixed inset-0 texture-overlay pointer-events-none z-0" />
      
      <Header />
      
      <main className="relative z-10">
        <HeroSection />
        <ProductOverview />
        <WhyCreatine />
        <ClinicalValidation />
        <BenefitsGrid />
        <NutritionFacts />
        <DirectionsForUse />
        <AboutBrand />
      </main>
      
      <Footer />
    </div>
  );
}
